import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

/**
 * Pushes a `virtual_pageview` event to dataLayer on every route change.
 * StrictMode double-invokes effects in dev — useRef guard ensures one event per route.
 */
export default function RouteAnalytics() {
    const loc = useLocation();
    const last = useRef(null);
    useEffect(() => {
        const key = loc.pathname + loc.search;
        if (last.current === key) return;
        last.current = key;
        trackPageView(key);
    }, [loc.pathname, loc.search]);
    return null;
}
